import config from "../config.json";
import { environment } from "../environment";

const ENV: string = environment;
const envConfig = (config as any)[ENV];

export interface IConfig {
  user?: string;
  csosUrl: string;
  csosPort?: number;
  registerCertificateURL: string;
  apiKeyCSOS: string;
  validatorURL: string;
  deleteUserIdCookie: string;
  deleteAccessTokenCookie: string;
  accountSelectionURL: string;
}

export class Config implements IConfig {
  public user: string;
  public csosUrl: string;
  public csosPort: number;
  public registerCertificateURL: string;
  public apiKeyCSOS: string;
  public validatorURL: string;
  public deleteUserIdCookie: string;
  public deleteAccessTokenCookie: string;
  public accountSelectionURL: string;

  constructor(
    user?: string,
    csosUrl?: string,
    csosPort?: number,
    registerCertificateURL?: string,
    apiKeyCSOS?: string,
    validatorURL?: string,
    deleteUserIdCookie?: string,
    deleteAccessTokenCookie?: string,
    accountSelectionURL?: string,
  ) {
    this.user = user ?? envConfig?.user ?? "";
    this.csosUrl = csosUrl ?? envConfig?.csosUrl ?? "";
    this.csosPort = csosPort ?? envConfig?.csosPort ?? 0;
    this.registerCertificateURL = registerCertificateURL ?? envConfig?.registerCertificateURL ?? "";
    this.apiKeyCSOS = apiKeyCSOS ?? envConfig?.apiKeyCSOS ?? "";
    this.validatorURL = validatorURL ?? envConfig?.validatorURL ?? "";
    this.deleteUserIdCookie = deleteUserIdCookie ?? envConfig?.deleteUserIdCookie ?? "";
    this.deleteAccessTokenCookie = deleteAccessTokenCookie ?? envConfig?.deleteAccessTokenCookie ?? "";
    this.accountSelectionURL = accountSelectionURL ?? envConfig?.accountSelectionURL ?? "";
  }
}
